import React, { useRef } from 'react';

import { LightDangerouslyHtml } from 'components/no-auth/common/fromAuth/LightDangerouslyHtml/LightDangerouslyHtml';
import { PromoInfoPage } from 'components/no-auth/common/PromoInfoPage/PromoInfoPage';
import PromoPopup from 'components/no-auth/popup/PromoPopup';

import { AUTH_PROFILE_INVITE, AUTH_SEND_MAIN_LINK } from 'constants/UrlConstants';

import { usePageMessages } from 'hooks/selectors';

import PromoSupportPopup from '../PromoSupportPopup';

const PromoFailed = (props) => {
    const popupRef = useRef(null);
    const { headerTitle, statusText, statusCancelTitle } = usePageMessages();

    return (
        <>
            <PromoInfoPage
                animatedIconFail
                headerText={headerTitle}
                secondaryText={<LightDangerouslyHtml dangerouslyHtml={statusText} />}
                primaryButtonCaption={statusCancelTitle}
                primaryButtonType="link"
                primaryButtonLink={props.status && props.status.showInviteCodeReferralButton ? AUTH_PROFILE_INVITE : AUTH_SEND_MAIN_LINK}
            />
            <PromoPopup ref={popupRef} />
        </>
    );
};

export default PromoFailed;
